import React from "react";
import { useSelector } from "react-redux";
import { Card, Col, FormGroup, Input, Label, Row } from "reactstrap";
import { Select } from "../../../../../..//components/Inputs/Input";
import * as actions from "../../../../../../store/modules/personas/parametros_store/actions";
import { AiOutlinePlusCircle } from "react-icons/ai";
import * as parametrosController from "../../../../../../controllers/personasController/parametrosController";
import TableCredencial from "./TableCredencial";
import TableParametro from "./TableParametro";
import InputVariable from "../../../../../../components/InputVariable/Input";
import TableParamatroTelecom from "./TableParametroTelecom";
import {
  PLATAFORMA_AGENTE_ID,
  PLATAFORMA_DISCADOR_ID,
  PLATAFORMA_MOLABOX_ID,
  PLATAFORMA_WHATSAPP_ID,
  PLATAFORMA_CHATWOOT_ID,
} from "../../../../../../util/constants";

const SeletorIntegracao = ({ id_integracao }) => {
  const { credenciais, item, seeRegister, integracoes, parametrosDePara } =
    useSelector((state) => state.personasParametros);
  const { tipoLoja } = useSelector((state) => state.personasPapeis);

  async function addCredencial() {
    if (item.id !== "") {
      await parametrosController.updateCredencial(item);
      parametrosController.getCredencial(tipoLoja.id);
    } else {
      parametrosController.createCredencial(item, tipoLoja.id);
    }

    actions.cleanItem();
  }

  const onChangeTelecom = (field, value) => {
    if (field === "plataformaIntegracaoId") {
      return actions.setItem({
        ...item,
        plataformaIntegracaoId: value,
        id: "",
        login: "",
        senha: "",
        url: "",
        plataforma: "",
        telecom_idDiscador: "",
        telecom_urlDiscador: "",
        telecom_login: "",
        telecom_senha: "",
        telecom_idAgente: "",
        telecom_url: "",
        telecom_usuarioApiAgente: "",
        telecom_senhaApiAgente: "",
        temRegistro: false,
      });
    }
    return actions.setItemField(field, value);
  };

  switch (id_integracao) {
    case "0":
      return (
        <Card
          className="p-3 m-4"
          style={{ backgroundColor: "var(--color-quase-branco)" }}
        >
          <Row>
            <Col md={4}>
              Escolha o tipo de integração para cadastrar os parâmetros
            </Col>
          </Row>
        </Card>
      );
    case "62f29e1b-7fd2-42b1-be17-7c716ab361bd":
      return (
        <>
          <Card
            className="p-3 m-4"
            style={{ backgroundColor: "var(--color-quase-branco)" }}
          >
            <Col>
              <Row>
                <Col md={4}>
                  <FormGroup>
                    <Label for="loginCredencial">Login</Label>
                    <Input
                      value={item.login}
                      disabled={seeRegister}
                      onChange={(e) =>
                        actions.setItemField("login", e.target.value)
                      }
                      id="loginCredencial"
                      placeholder="Digite aqui..."
                    />
                  </FormGroup>
                </Col>
                <Col md={4}>
                  <FormGroup>
                    <Label for="senhaCredencial">Senha</Label>
                    <Input
                      value={item.senha}
                      disabled={seeRegister}
                      onChange={(e) =>
                        actions.setItemField("senha", e.target.value)
                      }
                      id="senhaCredencial"
                      type="password"
                      placeholder="Digite aqui..."
                    />
                  </FormGroup>
                </Col>
              </Row>
              <Row>
                {!seeRegister &&
                  (!credenciais.length > 0 || item.id !== "") && (
                    <Col>
                      <Label className="mt-2">
                        <AiOutlinePlusCircle
                          style={{
                            fontSize: "1.5rem",
                            marginRight: "7px",
                            color: "green",
                            cursor: "pointer",
                          }}
                          onClick={() => addCredencial()}
                        />
                        Adicionar Credencial
                      </Label>
                    </Col>
                  )}
              </Row>
            </Col>
          </Card>
          {credenciais.length > 0 && (
            <TableCredencial credencial={credenciais} />
          )}
        </>
      );
    case "dcc7d5ea-8b74-43df-9a32-061373b1308e":
    case "f27e6218-9c1d-4018-b0d7-17f814c34c73":
      return (
        <>
          {integracoes.some((v) => v.temRegistro) ||
          !Object.values(integracoes).some((v) => !!v) ? (
            <Card
              className="p-3 m-4"
              style={{ backgroundColor: "var(--color-quase-branco)" }}
            >
              <Col>
                <Row>
                  <Col md={4}>
                    <FormGroup>
                      <Label>Plataforma</Label>
                      <Select
                        style={{ margin: "25px 0 0 25px" }}
                        first="Selecione"
                        value={{ value: item.plataformaIntegracaoId }}
                        onChange={(e) => {
                          if (e.value === PLATAFORMA_CHATWOOT_ID) {
                            actions.setItem({
                              ...item,
                              url: "N/A",
                            });
                          } else {
                            actions.setItem({
                              ...item,
                              url: "",
                            });
                          }
                          actions.setItemField(
                            "plataformaIntegracaoId",
                            e.value
                          );
                        }}
                        select={{ value: "id", label: "descricao" }}
                        options={[
                          {
                            id: PLATAFORMA_WHATSAPP_ID,
                            descricao: "WhatsApp Web",
                          },
                          {
                            id: PLATAFORMA_MOLABOX_ID,
                            descricao: "MolaBox",
                          },
                          {
                            id: PLATAFORMA_CHATWOOT_ID,
                            descricao: "Chatwoot",
                          },
                        ]}
                        isSearchable={false}
                      />
                    </FormGroup>
                  </Col>
                  {item.plataformaIntegracaoId !== PLATAFORMA_CHATWOOT_ID && (
                    <Col md={8}>
                      <FormGroup>
                        <Label for="urlIntegracao">URL</Label>
                        <InputVariable
                          rawValue={item.url}
                          onRawChange={(value) =>
                            actions.setItemField("url", value)
                          }
                          type="url"
                          placeholder="Digite aqui..."
                          variables={parametrosDePara}
                        />
                      </FormGroup>
                    </Col>
                  )}
                </Row>
              </Col>
            </Card>
          ) : (
            <></>
          )}
          {integracoes.some((v) => v.id) && (
            <TableParametro integracao={integracoes} isIntegracao={true} />
          )}
        </>
      );
    case "0d7b60a9-f267-439f-b3b9-7a7504feabec":
      return (
        <>
          {integracoes.some((v) => v.temRegistro) ||
          !Object.values(integracoes).some((v) => !!v) ? (
            <Card
              className="p-3 m-4"
              style={{ backgroundColor: "var(--color-quase-branco)" }}
            >
              <div className="d-flex flex-column row-gap-15">
                <Row>
                  <Col md={3}>
                    <FormGroup>
                      <Label>Plataforma</Label>
                      <Select
                        first="Selecione"
                        value={{ value: item.plataformaIntegracaoId }}
                        onChange={(e) =>
                          onChangeTelecom("plataformaIntegracaoId", e.value)
                        }
                        select={{ value: "id", label: "descricao" }}
                        options={[
                          {
                            id: PLATAFORMA_AGENTE_ID,
                            descricao: "Agente",
                          },
                          {
                            id: PLATAFORMA_DISCADOR_ID,
                            descricao: "Discador",
                          },
                        ]}
                        isSearchable={false}
                        disabled={
                          item.telecom_idDiscador || item.telecom_idAgente
                        }
                      />
                    </FormGroup>
                  </Col>
                  {(() => {
                    switch (item.plataformaIntegracaoId?.toUpperCase()) {
                      case PLATAFORMA_AGENTE_ID:
                        return (
                          <>
                            <Col md={3}>
                              <FormGroup>
                                <Label>URL</Label>
                                <Input
                                  value={item.telecom_url}
                                  onChange={(e) =>
                                    onChangeTelecom(
                                      "telecom_url",
                                      e.target.value
                                    )
                                  }
                                  placeholder="Digite aqui..."
                                  disabled={seeRegister}
                                />
                              </FormGroup>
                            </Col>
                            <Col md={3}>
                              <FormGroup>
                                <Label>Usuário</Label>
                                <Input
                                  value={item.telecom_usuarioApiAgente}
                                  onChange={(e) =>
                                    onChangeTelecom(
                                      "telecom_usuarioApiAgente",
                                      e.target.value
                                    )
                                  }
                                  placeholder="Digite aqui..."
                                  disabled={seeRegister}
                                />
                              </FormGroup>
                            </Col>
                            <Col md={3}>
                              <FormGroup>
                                <Label>Senha</Label>
                                <Input
                                  value={item.telecom_senhaApiAgente}
                                  onChange={(e) =>
                                    onChangeTelecom(
                                      "telecom_senhaApiAgente",
                                      e.target.value
                                    )
                                  }
                                  type="password"
                                  autoComplete="new-password"
                                  placeholder="Digite aqui..."
                                  disabled={seeRegister}
                                />
                              </FormGroup>
                            </Col>
                          </>
                        );
                      case PLATAFORMA_DISCADOR_ID:
                        return (
                          <>
                            <Col md={3}>
                              <FormGroup>
                                <Label>URL</Label>
                                <Input
                                  value={item.telecom_urlDiscador}
                                  onChange={(e) =>
                                    onChangeTelecom(
                                      "telecom_urlDiscador",
                                      e.target.value
                                    )
                                  }
                                  placeholder="Digite aqui..."
                                  disabled={seeRegister}
                                />
                              </FormGroup>
                            </Col>
                            <Col md={3}>
                              <FormGroup>
                                <Label>Usuário</Label>
                                <Input
                                  value={item.telecom_login}
                                  onChange={(e) =>
                                    onChangeTelecom(
                                      "telecom_login",
                                      e.target.value
                                    )
                                  }
                                  placeholder="Digite aqui..."
                                  disabled={seeRegister}
                                />
                              </FormGroup>
                            </Col>
                            <Col md={3}>
                              <FormGroup>
                                <Label>Senha</Label>
                                <Input
                                  value={item.telecom_senha}
                                  onChange={(e) =>
                                    onChangeTelecom(
                                      "telecom_senha",
                                      e.target.value
                                    )
                                  }
                                  type="password"
                                  autoComplete="new-password"
                                  placeholder="Digite aqui..."
                                  disabled={seeRegister}
                                />
                              </FormGroup>
                            </Col>
                          </>
                        );
                      default:
                        return;
                    }
                  })()}
                </Row>
              </div>
            </Card>
          ) : (
            <></>
          )}
          {integracoes.some(
            (item) => item.telecom_idDiscador || item.telecom_idAgente
          ) && (
            <TableParamatroTelecom
              integracao={integracoes}
              isIntegracao={true}
            />
          )}
        </>
      );
    default:
      return (
        <Card
          className="p-3 m-4"
          style={{ backgroundColor: "var(--color-quase-branco)" }}
        >
          <Row>
            <Col md={4}>Integração não parametrizada</Col>
          </Row>
        </Card>
      );
  }
};

export default SeletorIntegracao;
